import { FunctionComponent, HTMLAttributes } from 'react';

const FilterIcon: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props} width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.665 28C18.4939 27.9999 18.3239 27.9722 18.1617 27.918L12.8183 26.14C12.5006 26.0332 12.2246 25.829 12.0295 25.5564C11.8344 25.2837 11.7302 24.9566 11.7317 24.6214V16.4072L11.7257 16.3986L0.482416 3.30265C0.233109 3.01221 0.0723815 2.65633 0.0193153 2.27727C-0.0337509 1.8982 0.0230734 1.51187 0.183042 1.16413C0.34301 0.816402 0.599403 0.521876 0.92178 0.315525C1.24416 0.109174 1.61898 -0.000334253 2.00174 7.66397e-07H29.9983C30.381 -0.000334253 30.7558 0.109174 31.0782 0.315525C31.4006 0.521876 31.657 0.816402 31.817 1.16413C31.9769 1.51187 32.0338 1.8982 31.9807 2.27727C31.9276 2.65633 31.7669 3.01221 31.5176 3.30265L20.271 16.3999L20.265 16.4086V26.4C20.2656 26.6103 20.2246 26.8186 20.1444 27.013C20.0643 27.2074 19.9464 27.3841 19.7977 27.5327C19.649 27.6814 19.4724 27.7993 19.278 27.8795C19.0836 27.9597 18.8753 28.0006 18.665 28Z" fill="currentColor" />
  </svg>

);

export default FilterIcon;
